module.exports = __webpack_public_path__ + "img/orange-4.94c05d08.png";